module.exports = __webpack_public_path__ + "img/ic_cadastro.c601d424.svg";